var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.list
    ? _c(
        "v-container",
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "", align: "center", justify: "end" } },
            [
              _vm.list.length
                ? _c(
                    "v-col",
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", text: "" },
                              on: {
                                click: function ($event) {
                                  _vm.togglePanels(
                                    _vm.list.map((item, itemIndex) => itemIndex)
                                  )
                                },
                              },
                            },
                            [_vm._v(" Развернуть все ")]
                          ),
                          _c("v-divider", { attrs: { vertical: "" } }),
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", text: "" },
                              on: { click: _vm.togglePanels },
                            },
                            [_vm._v(" Свернуть все ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-spacer"),
              _vm.multipleCreating &&
              (_vm.availableItems || _vm.availableItems.length)
                ? _c(
                    "v-menu",
                    {
                      attrs: {
                        transition: "scroll-y-transition",
                        "offset-y": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(_vm._b({}, "v-btn", attrs, false), on),
                                  [
                                    _c("v-icon", { staticClass: "pr-1" }, [
                                      _vm._v(" mdi-plus "),
                                    ]),
                                    _c("span", [_vm._v("Добавить")]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2020028186
                      ),
                    },
                    [
                      _c(
                        "v-list",
                        _vm._l(_vm.availableItems, function (item, itemIndex) {
                          return _c(
                            "v-list-item",
                            {
                              key: itemIndex,
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("add", item)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(item.title) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$emit("add", _vm.availableItems[0])
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "pr-1" }, [
                        _vm._v(" mdi-plus "),
                      ]),
                      _c("span", [_vm._v("Добавить")]),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-expansion-panels",
                {
                  staticClass: "list-group",
                  attrs: { multiple: "", value: _vm.expansionPanels },
                },
                [
                  _c(
                    "draggable",
                    {
                      staticClass: "row no-gutters",
                      attrs: { value: _vm.list, handle: ".handle" },
                      on: {
                        start: _vm.togglePanels,
                        input: function ($event) {
                          return _vm.$emit("list-sort", $event)
                        },
                      },
                    },
                    _vm._l(_vm.list, function (item, itemIndex) {
                      return _c(
                        "v-expansion-panel",
                        { key: itemIndex, staticClass: "mb-5 list-group-item" },
                        [
                          _c(
                            "v-expansion-panel-header",
                            {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "actions",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              transition: "scroll-y-transition",
                                              "offset-y": "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    $event.preventDefault()
                                                                    return (() => {}).apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              " mdi-dots-vertical "
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "v-list",
                                              _vm._l(
                                                _vm.options,
                                                function (option, optionIndex) {
                                                  return _c(
                                                    "v-list-item",
                                                    {
                                                      key: optionIndex,
                                                      style: {
                                                        [option.borderDirection]:
                                                          option.borderStyle,
                                                      },
                                                      attrs: { dense: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.optionHandler(
                                                            option,
                                                            itemIndex,
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(option.title) +
                                                          " "
                                                      ),
                                                      _vm.copyClipboard.title
                                                        ? _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  option.showClipboardCopyTitle
                                                                    ? `(${_vm.copyClipboard.title})`
                                                                    : ""
                                                                ) +
                                                                " "
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "v-row",
                                { attrs: { align: "center" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "1" } },
                                    [
                                      _vm.sortAvailable
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "handle mr-2",
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return (() => {}).apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(" mdi-cursor-move "),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c("v-col", [
                                    _c(
                                      "p",
                                      {
                                        class: [
                                          item.data.hidden ? "grey--text" : "",
                                          _vm.errorMessages[itemIndex] !==
                                          undefined
                                            ? "error--text"
                                            : "",
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.title ||
                                                item.data.title ||
                                                itemIndex + 1
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.getTitle(item))),
                                    ]),
                                    item.data.hidden
                                      ? _c(
                                          "p",
                                          { staticClass: "ml-2 grey--text" },
                                          [_vm._v("(скрыт)")]
                                        )
                                      : _vm._e(),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-expansion-panel-content",
                            { attrs: { eager: "" } },
                            [
                              _vm._t("item", null, {
                                data: { item, itemIndex },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("ConfirmationDialog", {
            ref: "confirm",
            attrs: { confirmText: "ОК" },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }